export default __webpack_public_path__ + "static/manualNotes-a7a157dc04927cf24d8af492e7ed8010.png";